import React from 'react';
import { styled } from 'styled-components';
import THEME from '../theme.js';
const PageBaseStyled = styled.div `
  padding: ${THEME.GRID_SPACING}px;
  box-sizing: border-box;
`;
export const PageBase = (props) => (React.createElement(PageBaseStyled, { className: props.className }, props.children));
export default PageBase;
//# sourceMappingURL=PageBase.js.map